import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
    return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="text-center">
            <Link to="/login">
                <img src="/images/logo.png" alt="SE3D" className="img img-thumbnail" />
            </Link>
        </div>
    </div>
}

export default Home;